export function Updated({ date }: { date: string }) {
  return (
    <div className="w-p mx-auto">
      <hr />
      <p>Updated {date}</p>
    </div>
  );
}
